import React from "react";
import { noop } from "lodash";
import { Modal } from "react-bootstrap";

import TransferWidget from "components/transferWidget/TransferWidget";

import "./ContributionModal.scss";

interface ContributionModalOptions {
  isApplyToPriorYear?: boolean;
}

interface Props {
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
  onSuccess?: () => void;
  show?: boolean;
  depositOnly?: boolean;
  options?: ContributionModalOptions;
}

class ContributionModal extends React.PureComponent<Props> {
  render() {
    if (this.props.show) {
      return (
        <Modal
          centered
          scrollable
          show={this.props.show}
          onHide={noop}
          className="contribution-modal"
        >
          <Modal.Body>
            <TransferWidget
              {...this.props.options}
              onClose={this.props.onClose}
              onSuccess={this.props.onSuccess}
              depositOnly={this.props.depositOnly}
            />
          </Modal.Body>
        </Modal>
      );
    }
    return null;
  }
}

export default ContributionModal;
